var $fmoJJ$domrendererjsxruntime = require("dom-renderer/jsx-runtime");
var $fmoJJ$swchelperscjs_to_consumable_arraycjs = require("@swc/helpers/cjs/_to_consumable_array.cjs");
var $fmoJJ$swchelperscjs_call_supercjs = require("@swc/helpers/cjs/_call_super.cjs");
var $fmoJJ$swchelperscjs_class_call_checkcjs = require("@swc/helpers/cjs/_class_call_check.cjs");
var $fmoJJ$swchelperscjs_inheritscjs = require("@swc/helpers/cjs/_inherits.cjs");
var $fmoJJ$edkit = require("edkit");
var $fmoJJ$swchelperscjs_create_classcjs = require("@swc/helpers/cjs/_create_class.cjs");
var $fmoJJ$swchelperscjs_type_ofcjs = require("@swc/helpers/cjs/_type_of.cjs");
var $fmoJJ$mobx = require("mobx");
var $fmoJJ$webcell = require("web-cell");
var $fmoJJ$webutility = require("web-utility");


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $1e588696240c75da$exports = {};

$parcel$export($1e588696240c75da$exports, "renderTool", function () { return $1e588696240c75da$export$56ccecc1dac11363; });

function $1e588696240c75da$export$56ccecc1dac11363(editor) {
    var _this = this;
    var _this1 = this, title = _this1.title, active = _this1.active, icon = _this1.icon, usable = _this1.usable;
    var Class = "btn btn-".concat((active ? '' : 'outline-') + 'secondary', " me-2 mb-2");
    return (0, $fmoJJ$domrendererjsxruntime.jsx)("button", {
        type: "button",
        title: title,
        className: Class,
        style: {
            cursor: usable ? 'pointer' : 'not-allowed'
        },
        disabled: !usable,
        onClick: function(event) {
            event.preventDefault();
            _this.execute(editor);
        },
        children: (0, $fmoJJ$domrendererjsxruntime.jsx)("i", {
            className: "bi-".concat(icon)
        })
    }, icon);
}


var $890b39d956ebe4c3$exports = {};

$parcel$export($890b39d956ebe4c3$exports, "TextTools", function () { return $890b39d956ebe4c3$export$e252ba763eff5cdc; });
$parcel$export($890b39d956ebe4c3$exports, "ColorTools", function () { return $890b39d956ebe4c3$export$bdef6e97a10dbad4; });
$parcel$export($890b39d956ebe4c3$exports, "LayoutTools", function () { return $890b39d956ebe4c3$export$145c1b37c0810d7; });
$parcel$export($890b39d956ebe4c3$exports, "MediaTools", function () { return $890b39d956ebe4c3$export$999636c6e25075fb; });
$parcel$export($890b39d956ebe4c3$exports, "ControlTools", function () { return $890b39d956ebe4c3$export$f35db4b82786c3a4; });
$parcel$export($890b39d956ebe4c3$exports, "ExtraTools", function () { return $890b39d956ebe4c3$export$b8ecf7d74432d529; });
$parcel$export($890b39d956ebe4c3$exports, "OriginalTools", function () { return $890b39d956ebe4c3$export$9ddb256264948609; });
$parcel$export($890b39d956ebe4c3$exports, "DefaultTools", function () { return $890b39d956ebe4c3$export$aa718db1466ce312; });

var $e1696385b8f63bac$exports = {};

$parcel$export($e1696385b8f63bac$exports, "BoldTool", function () { return $e1696385b8f63bac$export$10056a49e3b218eb; });
$parcel$export($e1696385b8f63bac$exports, "ItalicTool", function () { return $e1696385b8f63bac$export$edf99d0f51bacb1e; });
$parcel$export($e1696385b8f63bac$exports, "UnderlineTool", function () { return $e1696385b8f63bac$export$4b6d9c17188960d2; });
$parcel$export($e1696385b8f63bac$exports, "StrikeThroughTool", function () { return $e1696385b8f63bac$export$a35bffaeae8fdda0; });
$parcel$export($e1696385b8f63bac$exports, "H1Tool", function () { return $e1696385b8f63bac$export$30e8c6b428f8749f; });
$parcel$export($e1696385b8f63bac$exports, "H2Tool", function () { return $e1696385b8f63bac$export$58443375efa91029; });
$parcel$export($e1696385b8f63bac$exports, "H3Tool", function () { return $e1696385b8f63bac$export$75d24d6b8b747307; });
$parcel$export($e1696385b8f63bac$exports, "FontSizeDownTool", function () { return $e1696385b8f63bac$export$a20806c6ef6938f8; });
$parcel$export($e1696385b8f63bac$exports, "FontSizeUpTool", function () { return $e1696385b8f63bac$export$744da7e24e4a7382; });
$parcel$export($e1696385b8f63bac$exports, "SubscriptTool", function () { return $e1696385b8f63bac$export$6137518b4e998008; });
$parcel$export($e1696385b8f63bac$exports, "SuperscriptTool", function () { return $e1696385b8f63bac$export$7217f06c61ebd4fc; });
$parcel$export($e1696385b8f63bac$exports, "LinkTool", function () { return $e1696385b8f63bac$export$f6c54364b5332e66; });





var $e1696385b8f63bac$export$10056a49e3b218eb = /*#__PURE__*/ function(BT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(BoldTool, BT);
    function BoldTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, BoldTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, BoldTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-bold'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return BoldTool;
}((0, $fmoJJ$edkit.BoldTool));
var $e1696385b8f63bac$export$edf99d0f51bacb1e = /*#__PURE__*/ function(IT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(ItalicTool, IT);
    function ItalicTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, ItalicTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, ItalicTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-italic'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return ItalicTool;
}((0, $fmoJJ$edkit.ItalicTool));
var $e1696385b8f63bac$export$4b6d9c17188960d2 = /*#__PURE__*/ function(UT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(UnderlineTool, UT);
    function UnderlineTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, UnderlineTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, UnderlineTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-underline'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return UnderlineTool;
}((0, $fmoJJ$edkit.UnderlineTool));
var $e1696385b8f63bac$export$a35bffaeae8fdda0 = /*#__PURE__*/ function(STT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(StrikeThroughTool, STT);
    function StrikeThroughTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, StrikeThroughTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, StrikeThroughTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-strikethrough'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return StrikeThroughTool;
}((0, $fmoJJ$edkit.StrikeThroughTool));
var $e1696385b8f63bac$export$30e8c6b428f8749f = /*#__PURE__*/ function(H1T) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(H1Tool, H1T);
    function H1Tool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, H1Tool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, H1Tool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-h1'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return H1Tool;
}((0, $fmoJJ$edkit.H1Tool));
var $e1696385b8f63bac$export$58443375efa91029 = /*#__PURE__*/ function(H2T) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(H2Tool, H2T);
    function H2Tool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, H2Tool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, H2Tool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-h2'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return H2Tool;
}((0, $fmoJJ$edkit.H2Tool));
var $e1696385b8f63bac$export$75d24d6b8b747307 = /*#__PURE__*/ function(H3T) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(H3Tool, H3T);
    function H3Tool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, H3Tool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, H3Tool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'type-h3'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return H3Tool;
}((0, $fmoJJ$edkit.H3Tool));
var $e1696385b8f63bac$export$a20806c6ef6938f8 = /*#__PURE__*/ function(FSDT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(FontSizeDownTool, FSDT);
    function FontSizeDownTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, FontSizeDownTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, FontSizeDownTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'sort-alpha-down'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return FontSizeDownTool;
}((0, $fmoJJ$edkit.FontSizeDownTool));
var $e1696385b8f63bac$export$744da7e24e4a7382 = /*#__PURE__*/ function(FSUT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(FontSizeUpTool, FSUT);
    function FontSizeUpTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, FontSizeUpTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, FontSizeUpTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'sort-alpha-up'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return FontSizeUpTool;
}((0, $fmoJJ$edkit.FontSizeUpTool));
var $e1696385b8f63bac$export$6137518b4e998008 = /*#__PURE__*/ function(SubST) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(SubscriptTool, SubST);
    function SubscriptTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, SubscriptTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, SubscriptTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'box-arrow-down-right'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return SubscriptTool;
}((0, $fmoJJ$edkit.SubscriptTool));
var $e1696385b8f63bac$export$7217f06c61ebd4fc = /*#__PURE__*/ function(SupST) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(SuperscriptTool, SupST);
    function SuperscriptTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, SuperscriptTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, SuperscriptTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'box-arrow-up-right'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return SuperscriptTool;
}((0, $fmoJJ$edkit.SuperscriptTool));
var $e1696385b8f63bac$export$f6c54364b5332e66 = /*#__PURE__*/ function(LT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(LinkTool, LT);
    function LinkTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, LinkTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, LinkTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'link'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return LinkTool;
}((0, $fmoJJ$edkit.LinkTool));


var $60eaebf063cf1b89$exports = {};

$parcel$export($60eaebf063cf1b89$exports, "ColorSelector", function () { return $60eaebf063cf1b89$export$9012acaf449cdfcb; });
$parcel$export($60eaebf063cf1b89$exports, "renderColorTool", function () { return $60eaebf063cf1b89$export$e913fac2ab7b6f29; });
$parcel$export($60eaebf063cf1b89$exports, "ForeColorTool", function () { return $60eaebf063cf1b89$export$cab0e15cfb8489d7; });
$parcel$export($60eaebf063cf1b89$exports, "BackColorTool", function () { return $60eaebf063cf1b89$export$92bb6183e7459be2; });





var $60eaebf063cf1b89$export$9012acaf449cdfcb = function(param) {
    var _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, title = param.title, type = param.type, value = param.value, onChange = param.onChange, icon = param.icon;
    return (0, $fmoJJ$domrendererjsxruntime.jsxs)("span", {
        className: "d-inline-block align-middle position-relative ".concat(className),
        title: title,
        children: [
            (0, $fmoJJ$domrendererjsxruntime.jsx)("input", {
                className: "position-absolute w-100 h-100 start-0 top-0 z-n1 rounded-3",
                type: "color",
                value: value,
                onChange: function(param) {
                    var target = param.target;
                    return onChange === null || onChange === void 0 ? void 0 : onChange(target.value);
                }
            }),
            (0, $fmoJJ$domrendererjsxruntime.jsx)("button", {
                className: "btn",
                style: {
                    color: type === 'color' ? value : 'lightgray',
                    backgroundColor: type === 'color' ? 'white' : value,
                    borderColor: value
                },
                onClick: function(event) {
                    event.preventDefault();
                    var input = event.currentTarget.previousElementSibling;
                    input.click();
                },
                children: (0, $fmoJJ$domrendererjsxruntime.jsx)("i", {
                    className: "bi-".concat(icon),
                    style: type !== 'color' ? {
                        filter: 'invert(1)'
                    } : undefined
                })
            })
        ]
    });
};
function $60eaebf063cf1b89$export$e913fac2ab7b6f29(editor) {
    var _this = this;
    var _this1 = this, icon = _this1.icon, name = _this1.name, colorName = _this1.colorName;
    return (0, $fmoJJ$domrendererjsxruntime.jsx)($60eaebf063cf1b89$export$9012acaf449cdfcb, {
        className: "me-2 mb-2",
        title: name,
        icon: icon,
        type: colorName,
        value: this.getColor(),
        onChange: function(color) {
            return _this.execute(editor, color);
        }
    }, icon);
}
var $60eaebf063cf1b89$export$cab0e15cfb8489d7 = /*#__PURE__*/ function(FCT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(ForeColorTool, FCT);
    function ForeColorTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, ForeColorTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, ForeColorTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'file-earmark-font'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $60eaebf063cf1b89$export$e913fac2ab7b6f29
        });
        return _this;
    }
    return ForeColorTool;
}((0, $fmoJJ$edkit.ForeColorTool));
var $60eaebf063cf1b89$export$92bb6183e7459be2 = /*#__PURE__*/ function(BCT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(BackColorTool, BCT);
    function BackColorTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, BackColorTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, BackColorTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'file-earmark-font-fill'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $60eaebf063cf1b89$export$e913fac2ab7b6f29
        });
        return _this;
    }
    return BackColorTool;
}((0, $fmoJJ$edkit.BackColorTool));


var $0c99bedc535c44da$exports = {};

$parcel$export($0c99bedc535c44da$exports, "AlignLeftTool", function () { return $0c99bedc535c44da$export$42a444ebfdcfe7b9; });
$parcel$export($0c99bedc535c44da$exports, "AlignCenterTool", function () { return $0c99bedc535c44da$export$9a2e6e0294a984eb; });
$parcel$export($0c99bedc535c44da$exports, "AlignRightTool", function () { return $0c99bedc535c44da$export$22363f91860fc258; });
$parcel$export($0c99bedc535c44da$exports, "AlignFullTool", function () { return $0c99bedc535c44da$export$42827b1362fed748; });
$parcel$export($0c99bedc535c44da$exports, "OrderedListTool", function () { return $0c99bedc535c44da$export$faf4e70f09f43a15; });
$parcel$export($0c99bedc535c44da$exports, "UnorderedListTool", function () { return $0c99bedc535c44da$export$cf4030b57a3fbe37; });
$parcel$export($0c99bedc535c44da$exports, "HorizontalRuleTool", function () { return $0c99bedc535c44da$export$dce8a7d6279fc201; });





var $0c99bedc535c44da$export$42a444ebfdcfe7b9 = /*#__PURE__*/ function(ALT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(AlignLeftTool, ALT);
    function AlignLeftTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, AlignLeftTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, AlignLeftTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'text-left'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return AlignLeftTool;
}((0, $fmoJJ$edkit.AlignLeftTool));
var $0c99bedc535c44da$export$9a2e6e0294a984eb = /*#__PURE__*/ function(ACT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(AlignCenterTool, ACT);
    function AlignCenterTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, AlignCenterTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, AlignCenterTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'text-center'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return AlignCenterTool;
}((0, $fmoJJ$edkit.AlignCenterTool));
var $0c99bedc535c44da$export$22363f91860fc258 = /*#__PURE__*/ function(ART) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(AlignRightTool, ART);
    function AlignRightTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, AlignRightTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, AlignRightTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'text-right'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return AlignRightTool;
}((0, $fmoJJ$edkit.AlignRightTool));
var $0c99bedc535c44da$export$42827b1362fed748 = /*#__PURE__*/ function(AFT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(AlignFullTool, AFT);
    function AlignFullTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, AlignFullTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, AlignFullTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'justify'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return AlignFullTool;
}((0, $fmoJJ$edkit.AlignFullTool));
var $0c99bedc535c44da$export$faf4e70f09f43a15 = /*#__PURE__*/ function(OLT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(OrderedListTool, OLT);
    function OrderedListTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, OrderedListTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, OrderedListTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'list-ol'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return OrderedListTool;
}((0, $fmoJJ$edkit.OrderedListTool));
var $0c99bedc535c44da$export$cf4030b57a3fbe37 = /*#__PURE__*/ function(ULT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(UnorderedListTool, ULT);
    function UnorderedListTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, UnorderedListTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, UnorderedListTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'list-ul'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return UnorderedListTool;
}((0, $fmoJJ$edkit.UnorderedListTool));
var $0c99bedc535c44da$export$dce8a7d6279fc201 = /*#__PURE__*/ function(HRT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(HorizontalRuleTool, HRT);
    function HorizontalRuleTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, HorizontalRuleTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, HorizontalRuleTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'reception-0'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return HorizontalRuleTool;
}((0, $fmoJJ$edkit.HorizontalRuleTool));


var $9f3af6eb45d5193b$exports = {};

$parcel$export($9f3af6eb45d5193b$exports, "IFrameTool", function () { return $9f3af6eb45d5193b$export$3e557574863db086; });
$parcel$export($9f3af6eb45d5193b$exports, "ImageTool", function () { return $9f3af6eb45d5193b$export$982f47444a2f88da; });
$parcel$export($9f3af6eb45d5193b$exports, "AudioTool", function () { return $9f3af6eb45d5193b$export$6024938f37e646f8; });
$parcel$export($9f3af6eb45d5193b$exports, "VideoTool", function () { return $9f3af6eb45d5193b$export$932111b8028f79ed; });





var $9f3af6eb45d5193b$export$3e557574863db086 = /*#__PURE__*/ function(FT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(IFrameTool, FT);
    function IFrameTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, IFrameTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, IFrameTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'window'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return IFrameTool;
}((0, $fmoJJ$edkit.IFrameTool));
var $9f3af6eb45d5193b$export$982f47444a2f88da = /*#__PURE__*/ function(IT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(ImageTool, IT);
    function ImageTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, ImageTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, ImageTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'image'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return ImageTool;
}((0, $fmoJJ$edkit.ImageTool));
var $9f3af6eb45d5193b$export$6024938f37e646f8 = /*#__PURE__*/ function(AT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(AudioTool, AT);
    function AudioTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, AudioTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, AudioTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'voicemail'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return AudioTool;
}((0, $fmoJJ$edkit.AudioTool));
var $9f3af6eb45d5193b$export$932111b8028f79ed = /*#__PURE__*/ function(VT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(VideoTool, VT);
    function VideoTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, VideoTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, VideoTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'camera-video'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return VideoTool;
}((0, $fmoJJ$edkit.VideoTool));


var $bdc062d435e566e2$exports = {};

$parcel$export($bdc062d435e566e2$exports, "UndoTool", function () { return $bdc062d435e566e2$export$65235875731ff287; });
$parcel$export($bdc062d435e566e2$exports, "RedoTool", function () { return $bdc062d435e566e2$export$b60f30d254d1e1a6; });
$parcel$export($bdc062d435e566e2$exports, "ResetTool", function () { return $bdc062d435e566e2$export$6f46dc3d81fbb4bd; });
$parcel$export($bdc062d435e566e2$exports, "ClearTool", function () { return $bdc062d435e566e2$export$25eb377ce1feaada; });





var $bdc062d435e566e2$export$65235875731ff287 = /*#__PURE__*/ function(UDT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(UndoTool, UDT);
    function UndoTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, UndoTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, UndoTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'arrow-counterclockwise'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return UndoTool;
}((0, $fmoJJ$edkit.UndoTool));
var $bdc062d435e566e2$export$b60f30d254d1e1a6 = /*#__PURE__*/ function(RDT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(RedoTool, RDT);
    function RedoTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, RedoTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, RedoTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'arrow-clockwise'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return RedoTool;
}((0, $fmoJJ$edkit.RedoTool));
var $bdc062d435e566e2$export$6f46dc3d81fbb4bd = /*#__PURE__*/ function(RST) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(ResetTool, RST);
    function ResetTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, ResetTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, ResetTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'eraser'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return ResetTool;
}((0, $fmoJJ$edkit.ResetTool));
var $bdc062d435e566e2$export$25eb377ce1feaada = /*#__PURE__*/ function(CT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(ClearTool, CT);
    function ClearTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, ClearTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, ClearTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'file-earmark-x'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return ClearTool;
}((0, $fmoJJ$edkit.ClearTool));


var $ce0084e1a8e78ab8$exports = {};

$parcel$export($ce0084e1a8e78ab8$exports, "CopyMarkdownTool", function () { return $ce0084e1a8e78ab8$export$4b13df0a6effdd72; });





var $ce0084e1a8e78ab8$export$4b13df0a6effdd72 = /*#__PURE__*/ function(CMDT) {
    "use strict";
    (0, $fmoJJ$swchelperscjs_inheritscjs._)(CopyMarkdownTool, CMDT);
    function CopyMarkdownTool() {
        (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, CopyMarkdownTool);
        var _this;
        _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, CopyMarkdownTool, arguments);
        Object.defineProperty(_this, "icon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'markdown'
        });
        Object.defineProperty(_this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $1e588696240c75da$export$56ccecc1dac11363)
        });
        return _this;
    }
    return CopyMarkdownTool;
}((0, $fmoJJ$edkit.CopyMarkdownTool));


var $890b39d956ebe4c3$export$e252ba763eff5cdc = [
    (0, $e1696385b8f63bac$export$10056a49e3b218eb),
    (0, $e1696385b8f63bac$export$edf99d0f51bacb1e),
    (0, $e1696385b8f63bac$export$4b6d9c17188960d2),
    (0, $e1696385b8f63bac$export$a35bffaeae8fdda0),
    (0, $e1696385b8f63bac$export$30e8c6b428f8749f),
    (0, $e1696385b8f63bac$export$58443375efa91029),
    (0, $e1696385b8f63bac$export$75d24d6b8b747307),
    (0, $e1696385b8f63bac$export$a20806c6ef6938f8),
    (0, $e1696385b8f63bac$export$744da7e24e4a7382),
    (0, $e1696385b8f63bac$export$6137518b4e998008),
    (0, $e1696385b8f63bac$export$7217f06c61ebd4fc),
    (0, $e1696385b8f63bac$export$f6c54364b5332e66)
];
var $890b39d956ebe4c3$export$bdef6e97a10dbad4 = [
    (0, $60eaebf063cf1b89$export$cab0e15cfb8489d7),
    (0, $60eaebf063cf1b89$export$92bb6183e7459be2)
];
var $890b39d956ebe4c3$export$145c1b37c0810d7 = [
    (0, $0c99bedc535c44da$export$42a444ebfdcfe7b9),
    (0, $0c99bedc535c44da$export$9a2e6e0294a984eb),
    (0, $0c99bedc535c44da$export$22363f91860fc258),
    (0, $0c99bedc535c44da$export$42827b1362fed748),
    (0, $0c99bedc535c44da$export$faf4e70f09f43a15),
    (0, $0c99bedc535c44da$export$cf4030b57a3fbe37),
    (0, $0c99bedc535c44da$export$dce8a7d6279fc201)
];
var $890b39d956ebe4c3$export$999636c6e25075fb = [
    (0, $9f3af6eb45d5193b$export$3e557574863db086),
    (0, $9f3af6eb45d5193b$export$982f47444a2f88da),
    (0, $9f3af6eb45d5193b$export$6024938f37e646f8),
    (0, $9f3af6eb45d5193b$export$932111b8028f79ed)
];
var $890b39d956ebe4c3$export$f35db4b82786c3a4 = [
    (0, $bdc062d435e566e2$export$65235875731ff287),
    (0, $bdc062d435e566e2$export$b60f30d254d1e1a6),
    (0, $bdc062d435e566e2$export$6f46dc3d81fbb4bd),
    (0, $bdc062d435e566e2$export$25eb377ce1feaada)
];
var $890b39d956ebe4c3$export$b8ecf7d74432d529 = [
    (0, $ce0084e1a8e78ab8$export$4b13df0a6effdd72)
];
var $890b39d956ebe4c3$export$9ddb256264948609 = (0, $fmoJJ$swchelperscjs_to_consumable_arraycjs._)($890b39d956ebe4c3$export$e252ba763eff5cdc).concat((0, $fmoJJ$swchelperscjs_to_consumable_arraycjs._)($890b39d956ebe4c3$export$bdef6e97a10dbad4), (0, $fmoJJ$swchelperscjs_to_consumable_arraycjs._)($890b39d956ebe4c3$export$145c1b37c0810d7), (0, $fmoJJ$swchelperscjs_to_consumable_arraycjs._)($890b39d956ebe4c3$export$999636c6e25075fb), (0, $fmoJJ$swchelperscjs_to_consumable_arraycjs._)($890b39d956ebe4c3$export$f35db4b82786c3a4));
var $890b39d956ebe4c3$export$aa718db1466ce312 = [
    (0, $e1696385b8f63bac$export$10056a49e3b218eb),
    (0, $e1696385b8f63bac$export$edf99d0f51bacb1e),
    (0, $e1696385b8f63bac$export$4b6d9c17188960d2),
    (0, $e1696385b8f63bac$export$a35bffaeae8fdda0),
    (0, $e1696385b8f63bac$export$30e8c6b428f8749f),
    (0, $e1696385b8f63bac$export$58443375efa91029),
    (0, $e1696385b8f63bac$export$75d24d6b8b747307),
    (0, $e1696385b8f63bac$export$6137518b4e998008),
    (0, $e1696385b8f63bac$export$7217f06c61ebd4fc),
    (0, $60eaebf063cf1b89$export$cab0e15cfb8489d7),
    (0, $60eaebf063cf1b89$export$92bb6183e7459be2),
    (0, $0c99bedc535c44da$export$42a444ebfdcfe7b9),
    (0, $0c99bedc535c44da$export$9a2e6e0294a984eb),
    (0, $0c99bedc535c44da$export$22363f91860fc258),
    (0, $0c99bedc535c44da$export$42827b1362fed748),
    (0, $0c99bedc535c44da$export$faf4e70f09f43a15),
    (0, $0c99bedc535c44da$export$cf4030b57a3fbe37),
    (0, $0c99bedc535c44da$export$dce8a7d6279fc201),
    (0, $9f3af6eb45d5193b$export$982f47444a2f88da),
    (0, $bdc062d435e566e2$export$65235875731ff287),
    (0, $bdc062d435e566e2$export$b60f30d254d1e1a6),
    (0, $bdc062d435e566e2$export$25eb377ce1feaada)
];
$parcel$exportWildcard($890b39d956ebe4c3$exports, $e1696385b8f63bac$exports);
$parcel$exportWildcard($890b39d956ebe4c3$exports, $60eaebf063cf1b89$exports);
$parcel$exportWildcard($890b39d956ebe4c3$exports, $0c99bedc535c44da$exports);
$parcel$exportWildcard($890b39d956ebe4c3$exports, $9f3af6eb45d5193b$exports);
$parcel$exportWildcard($890b39d956ebe4c3$exports, $bdc062d435e566e2$exports);
$parcel$exportWildcard($890b39d956ebe4c3$exports, $ce0084e1a8e78ab8$exports);


var $34e8cbf87edba6f7$exports = {};

$parcel$export($34e8cbf87edba6f7$exports, "HTMLEditor", function () { return $34e8cbf87edba6f7$export$ef72d30fb6679cb4; });












var $34e8cbf87edba6f7$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $34e8cbf87edba6f7$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $fmoJJ$swchelperscjs_type_ofcjs._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $34e8cbf87edba6f7$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $fmoJJ$swchelperscjs_type_ofcjs._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $34e8cbf87edba6f7$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $34e8cbf87edba6f7$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $34e8cbf87edba6f7$var$shallow = (0, $fmoJJ$mobx.observableShallow) || Reflect.get((0, $fmoJJ$mobx.observable), 'shallow', (0, $fmoJJ$mobx.observable));
var $34e8cbf87edba6f7$export$ef72d30fb6679cb4 = function() {
    var _HTMLEditor_tools_accessor_storage, _HTMLEditor_toolList_accessor_storage;
    var _classDecorators = [
        (0, $fmoJJ$webcell.component)({
            tagName: 'html-editor',
            mode: 'open'
        }),
        (0, $fmoJJ$webcell.formField),
        (0, $fmoJJ$webcell.observer),
        (0, $fmoJJ$edkit.editor)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = HTMLElement;
    var _instanceExtraInitializers = [];
    var _tools_decorators;
    var _tools_initializers = [];
    var _tools_extraInitializers = [];
    var _toolList_decorators;
    var _toolList_initializers = [];
    var _toolList_extraInitializers = [];
    var _get_imageTool_decorators;
    var _get_audioTool_decorators;
    var _get_videoTool_decorators;
    var _bootTools_decorators;
    var HTMLEditor = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $fmoJJ$swchelperscjs_inheritscjs._)(_classThis, _classSuper);
        function _classThis() {
            (0, $fmoJJ$swchelperscjs_class_call_checkcjs._)(this, _classThis);
            var _this;
            _this = (0, $fmoJJ$swchelperscjs_call_supercjs._)(this, _classThis, arguments);
            _HTMLEditor_tools_accessor_storage.set(_this, ($34e8cbf87edba6f7$var$__runInitializers(_this, _instanceExtraInitializers), $34e8cbf87edba6f7$var$__runInitializers(_this, _tools_initializers, void 0)));
            _HTMLEditor_toolList_accessor_storage.set(_this, ($34e8cbf87edba6f7$var$__runInitializers(_this, _tools_extraInitializers), $34e8cbf87edba6f7$var$__runInitializers(_this, _toolList_initializers, [])));
            Object.defineProperty(_this, "box", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $34e8cbf87edba6f7$var$__runInitializers(_this, _toolList_extraInitializers)
            });
            Object.defineProperty(_this, "updateTools", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    if (_this.box === document.activeElement) _this.toolList = (0, $fmoJJ$swchelperscjs_to_consumable_arraycjs._)(_this.toolList);
                }
            });
            Object.defineProperty(_this, "updateValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(markup) {
                    return _this.emit('change', _this.value = markup.trim());
                }
            });
            return _this;
        }
        (0, $fmoJJ$swchelperscjs_create_classcjs._)(_classThis, [
            {
                key: "tools",
                get: function get() {
                    return $34e8cbf87edba6f7$var$__classPrivateFieldGet(this, _HTMLEditor_tools_accessor_storage, "f");
                },
                set: function set(value) {
                    $34e8cbf87edba6f7$var$__classPrivateFieldSet(this, _HTMLEditor_tools_accessor_storage, value, "f");
                }
            },
            {
                key: "toolList",
                get: function get() {
                    return $34e8cbf87edba6f7$var$__classPrivateFieldGet(this, _HTMLEditor_toolList_accessor_storage, "f");
                },
                set: function set(value) {
                    $34e8cbf87edba6f7$var$__classPrivateFieldSet(this, _HTMLEditor_toolList_accessor_storage, value, "f");
                }
            },
            {
                key: "imageTool",
                get: function get() {
                    return this.toolList.find(function(tool) {
                        return tool instanceof (0, $fmoJJ$edkit.ImageTool);
                    });
                }
            },
            {
                key: "audioTool",
                get: function get() {
                    return this.toolList.find(function(tool) {
                        return tool instanceof (0, $9f3af6eb45d5193b$export$6024938f37e646f8);
                    });
                }
            },
            {
                key: "videoTool",
                get: function get() {
                    return this.toolList.find(function(tool) {
                        return tool instanceof (0, $9f3af6eb45d5193b$export$932111b8028f79ed);
                    });
                }
            },
            {
                key: "mountedCallback",
                value: function mountedCallback() {
                    var _this = this;
                    this.bootTools();
                    this.box = (0, $fmoJJ$webutility.parseDOM)('\n<div\n    class="form-control h-auto"\n    contenteditable="true"\n    tabindex="0"\n    role="textbox"\n    aria-multiline="true"\n>\n    '.concat(this.defaultValue || '', "\n</div>"))[0];
                    this.box.oninput = function() {
                        return _this.updateValue(_this.box.innerHTML);
                    };
                    this.box.onpaste = this.box.ondrop = this.handlePasteDrop;
                    this.append(this.box);
                    document.addEventListener('selectionchange', this.updateTools);
                }
            },
            {
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    document.removeEventListener('selectionchange', this.updateTools);
                }
            },
            {
                key: "bootTools",
                value: function bootTools() {
                    this.toolList = (this.tools || (0, $890b39d956ebe4c3$export$aa718db1466ce312)).map(function(ToolButton) {
                        return new ToolButton();
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    return (0, $fmoJJ$domrendererjsxruntime.jsxs)((0, $fmoJJ$domrendererjsxruntime.Fragment), {
                        children: [
                            (0, $fmoJJ$domrendererjsxruntime.jsx)("link", {
                                rel: "stylesheet",
                                href: "https://unpkg.com/bootstrap@5.3.8/dist/css/bootstrap.min.css"
                            }),
                            (0, $fmoJJ$domrendererjsxruntime.jsx)("link", {
                                rel: "stylesheet",
                                href: "https://unpkg.com/bootstrap-icons@1.13.1/font/bootstrap-icons.css"
                            }),
                            (0, $fmoJJ$domrendererjsxruntime.jsx)("header", {
                                children: this.toolList.map(function(tool) {
                                    return tool.render(_this.box);
                                })
                            }),
                            (0, $fmoJJ$domrendererjsxruntime.jsx)("slot", {})
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _HTMLEditor_tools_accessor_storage = new WeakMap();
    _HTMLEditor_toolList_accessor_storage = new WeakMap();
    $34e8cbf87edba6f7$var$__setFunctionName(_classThis, "HTMLEditor");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _tools_decorators = [
            $34e8cbf87edba6f7$var$shallow
        ];
        _toolList_decorators = [
            (0, $fmoJJ$mobx.observable)
        ];
        _get_imageTool_decorators = [
            (0, $fmoJJ$mobx.computed)
        ];
        _get_audioTool_decorators = [
            (0, $fmoJJ$mobx.computed)
        ];
        _get_videoTool_decorators = [
            (0, $fmoJJ$mobx.computed)
        ];
        _bootTools_decorators = [
            (0, $fmoJJ$webcell.reaction)(function(param) {
                var tools = param.tools;
                return tools;
            })
        ];
        $34e8cbf87edba6f7$var$__esDecorate(_classThis, null, _tools_decorators, {
            kind: "accessor",
            name: "tools",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "tools" in obj;
                },
                get: function(obj) {
                    return obj.tools;
                },
                set: function(obj, value) {
                    obj.tools = value;
                }
            },
            metadata: _metadata
        }, _tools_initializers, _tools_extraInitializers);
        $34e8cbf87edba6f7$var$__esDecorate(_classThis, null, _toolList_decorators, {
            kind: "accessor",
            name: "toolList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "toolList" in obj;
                },
                get: function(obj) {
                    return obj.toolList;
                },
                set: function(obj, value) {
                    obj.toolList = value;
                }
            },
            metadata: _metadata
        }, _toolList_initializers, _toolList_extraInitializers);
        $34e8cbf87edba6f7$var$__esDecorate(_classThis, null, _get_imageTool_decorators, {
            kind: "getter",
            name: "imageTool",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "imageTool" in obj;
                },
                get: function(obj) {
                    return obj.imageTool;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $34e8cbf87edba6f7$var$__esDecorate(_classThis, null, _get_audioTool_decorators, {
            kind: "getter",
            name: "audioTool",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "audioTool" in obj;
                },
                get: function(obj) {
                    return obj.audioTool;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $34e8cbf87edba6f7$var$__esDecorate(_classThis, null, _get_videoTool_decorators, {
            kind: "getter",
            name: "videoTool",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "videoTool" in obj;
                },
                get: function(obj) {
                    return obj.videoTool;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $34e8cbf87edba6f7$var$__esDecorate(_classThis, null, _bootTools_decorators, {
            kind: "method",
            name: "bootTools",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "bootTools" in obj;
                },
                get: function(obj) {
                    return obj.bootTools;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $34e8cbf87edba6f7$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        HTMLEditor = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $34e8cbf87edba6f7$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return HTMLEditor = _classThis;
}();


$parcel$exportWildcard(module.exports, $1e588696240c75da$exports);
$parcel$exportWildcard(module.exports, $890b39d956ebe4c3$exports);
$parcel$exportWildcard(module.exports, $34e8cbf87edba6f7$exports);


//# sourceMappingURL=index.js.map
